<template>
  <div class="filter-bar card">
    <div class="filter-grid">
      <div class="filter-field">
        <label class="label" for="filter-type">نوع العملية</label>
        <select
          id="filter-type"
          class="select"
          :value="modelValue.type"
          @change="update('type', $event.target.value)"
        >
          <option value="">الكل</option>
          <option value="sale">للبيع</option>
          <option value="rent">للإيجار</option>
        </select>
      </div>
      <div class="filter-field">
        <label class="label" for="filter-category">نوع العقار</label>
        <select
          id="filter-category"
          class="select"
          :value="modelValue.category"
          @change="update('category', $event.target.value)"
        >
          <option value="">الكل</option>
          <option value="villa">فيلا</option>
          <option value="apartment">شقة</option>
          <option value="duplex">دوبlex</option>
          <option value="commercial">تجاري</option>
          <option value="land">أرض</option>
        </select>
      </div>
      <div class="filter-field">
        <label class="label" for="filter-area">المنطقة</label>
        <select
          id="filter-area"
          class="select"
          :value="modelValue.area"
          @change="update('area', $event.target.value)"
        >
          <option value="">كل المناطق</option>
          <option v-for="a in areas" :key="a.slug" :value="a.slug">
            {{ a.name }}
          </option>
        </select>
      </div>
      <div class="filter-field">
        <label class="label" for="filter-price-min">السعر من (د.ك)</label>
        <input
          id="filter-price-min"
          class="input"
          type="number"
          min="0"
          placeholder="0"
          :value="modelValue.priceMin"
          @input="update('priceMin', $event.target.value)"
        />
      </div>
      <div class="filter-field">
        <label class="label" for="filter-price-max">السعر إلى (د.ك)</label>
        <input
          id="filter-price-max"
          class="input"
          type="number"
          min="0"
          placeholder="∞"
          :value="modelValue.priceMax"
          @input="update('priceMax', $event.target.value)"
        />
      </div>
      <div class="filter-field">
        <label class="label" for="filter-search">بحث</label>
        <input
          id="filter-search"
          class="input"
          type="search"
          placeholder="ابحث بالموقع أو الاسم..."
          :value="modelValue.search"
          @input="update('search', $event.target.value)"
        />
      </div>
    </div>
    <div class="filter-footer">
      <p
        v-if="resultCount !== null"
        class="result-count muted"
        aria-live="polite"
      >
        {{ resultCount }} عقار متاح
      </p>
      <button type="button" class="btn btn-ghost" @click="$emit('clear')">
        مسح الفلاتر
        <span v-if="activeCount" class="filter-count">{{ activeCount }}</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { areas } from "@/data/areas";

const props = defineProps({
  modelValue: { type: Object, required: true },
  resultCount: { type: Number, default: null },
});

const emit = defineEmits(["update:modelValue", "clear"]);

const activeCount = computed(() => {
  let count = 0;
  const f = props.modelValue;
  if (f.type) count++;
  if (f.category) count++;
  if (f.area) count++;
  if (f.search) count++;
  if (f.priceMin) count++;
  if (f.priceMax) count++;
  return count;
});

function update(key, value) {
  emit("update:modelValue", { ...props.modelValue, [key]: value });
}
</script>

<style scoped>
.filter-bar {
  margin-bottom: var(--section-gap);
}

.filter-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

@media (min-width: 640px) {
  .filter-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .filter-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.filter-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid var(--border);
  flex-wrap: wrap;
}

.filter-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  background: var(--brand);
  color: #fff;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  margin-inline-start: 6px;
}

.result-count {
  margin: 0;
  font-size: 0.875rem;
}
</style>
